import React from 'react';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../../common/SafeIcon';

const { FaApple, FaGooglePlay } = FaIcons;

const APP_STORE_URL = "https://apps.apple.com/us/app/nisaa/id6772802488";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=uk.co.sussexendocrineclinic.nisaa";

const Footer = () => {
  return (
    <footer className="py-16 text-muted bg-aubergine-dark">
      <div className="w-full max-w-[1120px] mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 lg:col-span-2">
            <strong className="text-white block mb-4 text-2xl">Nisaa</strong>
            <p className="text-white/60 max-w-sm leading-relaxed mb-8">
              A private, faith-first health companion for Muslim women. No ads, no tracking, just your journey.
            </p>
            <div className="flex gap-4">
              <a 
                href={APP_STORE_URL} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 rounded-xl bg-white/5 text-white flex items-center justify-center hover:bg-rose transition-colors"
                title="Download on App Store"
              >
                <SafeIcon icon={FaApple} className="w-5 h-5" />
              </a>
              <a 
                href={PLAY_STORE_URL} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 rounded-xl bg-white/5 text-white flex items-center justify-center hover:bg-teal transition-colors"
                title="Get it on Google Play"
              >
                <SafeIcon icon={FaGooglePlay} className="w-4 h-4" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4 uppercase text-xs tracking-widest">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/contact" className="hover:text-rose transition-colors">Contact Us</Link></li>
              <li><a href="mailto:contact@sussexendocrineclinic.co.uk" className="hover:text-rose transition-colors">Support Email</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 uppercase text-xs tracking-widest">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/privacy" className="hover:text-rose transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-rose transition-colors">Terms of Use</Link></li>
              <li><Link to="/disclaimer" className="hover:text-rose transition-colors">Disclaimers</Link></li>
              <li><Link to="/account-deletion" className="hover:text-rose transition-colors">Account Deletion</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Sussex Endocrine Clinic. Operating from the United Kingdom.</p>
          <p>Built with privacy as a human right.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;